import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { TareaService } from '../../../../../services/tarea.service';
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { Toast } from 'ngx-toastr';
import { ScnackbarData, SnackbarStyles, ToastService } from '../../../../../commons/toast.service';


@Component({
  selector: 'app-dlg-reasignacion-masiva',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatProgressBarModule],
  templateUrl: './dlg-reasignacion-masiva.component.html',
  styleUrls: ['./dlg-reasignacion-masiva.component.scss']
})
export class DlgReasignacionMasivaComponent {

  snackbarData: ScnackbarData = {}
  saving = false;
  constructor(
    public dialogRef: MatDialogRef<DlgReasignacionMasivaComponent>,   
    private tareaService: TareaService,
    private toast: ToastService,    
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  onConfirm(): void {
    this.saving = true;
    const reasignacionData = {
      idParticipanteOrigen: this.data.data.origen.id,
      idParticipanteDestino: this.data.data.destinatario.id,
      comentario: this.data.data.comentario
    };
    this.tareaService.reasignarDocumentosMasivo(reasignacionData).subscribe({
      next: (res: any) => {
        this.saving = false;
        this.snackbarData.message = "Documentos reasignados correctamente"
        this.snackbarData.style = SnackbarStyles.Success
        this.snackbarData.iconName = "check_circle"                
        this.toast.show(this.snackbarData)
        
      },
      error: () => {
        this.snackbarData.message = "prbolemas al reasignar"
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"                
        this.toast.show(this.snackbarData)        
        this.saving = false;
        this.dialogRef.close();
      }
      
    })

    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
